import { useEffect, useMemo, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { Segmented, Skeleton } from 'antd';
import { SVGPureIcon } from '@/ui';
import chatStoreManager from '@/store/chat/manager';
import Code from './components/code';

const CardNewSearch = observer((props) => {
  const {
    results,
    event,
    mcpStore,
    errorMsg,
    currentDark,
    callbackTabs,
  } = props;

  const [alignValue, setAlignValue] = useState('搜索结果');
  const [queryList, setQueryList] = useState([]);
  const chatStore = chatStoreManager.current;
  const messageItem = chatStore.messageMap.get(event.msg_id)

  const tabList = useMemo(() => {
    const list = ['搜索结果'];
    const text = event?.querys || event?.text || event?.detail?.querys; // 前两2个是老的数据格式
    if (text) {
      list.push('拆词');
      setQueryList(text.split('|'))
    }
    const paramsText = mcpStore.getNodeParamsText(event);
    if (paramsText) {
      list.push('工具参数');
    }
    return list;
  }, [event]);

  const store = useLocalObservable(() => ({
    process : [],
    timer : null,

    setProcess (process) {
      this.process = process;
    },
    setTimer (timer) {
      this.timer = timer;
    }
  }));

  useEffect(() => {
    return () => {
      clearInterval(store.timer);
    }
  }, []);

  const memoizedResult = useMemo(() => results, [results.length])
  
  useEffect(() => {
    // EE.emit("vnc-cards-scroll");
    if (messageItem?.is_history) {
      store.setProcess(new Array(memoizedResult.length).fill(100));
      return
    }
    // if (event?.status !== 'running') {
      store.setProcess(new Array(memoizedResult.length).fill(0));
      store.setTimer(setInterval(() => {
        const list = [...store.process];
        for (let i = 0, len = list.length; i < len; i++) {
          const rnd = Math.ceil(Math.random() * 6);
          if (list[i] < 100) {
            list[i] += rnd;
            if (list[i] > 100) {
              list[i] = 100;
            }
          }
        }
        store.setProcess(list)
      }, 200)) 
    // } else {
    //   store.setProcess(new Array(results.length).fill(100));
    // }
  }, [memoizedResult]);

  const onTabChange = (value) => {
    setAlignValue(value);
    callbackTabs && callbackTabs(value);
  }
  
  return (
    <>
      <div className='py-16px pl-24px tabs'>
        <Segmented
          value={alignValue}
          onChange={onTabChange}
          options={tabList}
        />
      </div>

      <div className={[
        "px-24px pr-16px mr-4px mb-16px flex-grow overflow-x-hidden overflow-y-auto",
        currentDark ? 'scrollbar-dark' : 'scrollbar'
        ]}>
        {
          alignValue === '搜索结果' ? (
            <>
            {
              event?.status == "failed"
              ? (
                <div className="flex flex-col h-400px items-center justify-center">
                  <img 
                    className='w-190px'
                    src='https://p5.ssl.qhimg.com/t11098f6bcda6a604f3f799138d.png'
                    />
                  <div className="text-14px leading-30px text-black text-opacity-50">
                    {errorMsg}
                  </div>
                </div>
              )
              : results?.length === 0 ? <Skeleton active /> : (
                <>
                <div className='mt-10px mb-16px'>{event?.detail?.site_num && `本次搜索已进行重排序，共获得 ${event?.detail?.site_num || 0} 个信源、`}共获得{results.length} 个搜索结果：</div>
                <ul className="">
                {
                  results && results.map((item, index) => {
                    const {
                      title,
                      summary_large,
                      url,
                      site_name,
                      favicon,
                      date,
                      icon,
                    } = item;
                    const currProcess = store.process[index] || 0;

                    return (
                      <li className="bg-[#F5F5F5] hover:bg-[#f7f7f7] rounded-12px mb-8px last-of-type:mb-0" key={`page_${index}`}>
                        <a className="px-20px rounded-12px block text-14px leading-20px !text-black hover:text-black py-16px relative overflow-hidden" href={url} target='_blank'>
                          <div className="flex">
                            <div className="size-48px flex-shrink-0 mr-16px">
                              <img className='size-full' src={icon || 'https://p0.ssl.qhimg.com/t11098f6bcd304c1f3bb3bb27ef.png'} />
                            </div>
                            <div className="w-0 flex-grow">
                              <h3 className="font-normal truncate text-14px leading-20px mb-6px">{title}</h3>
                              <div className="flex items-center mb-6px">
                                {
                                  currProcess < 100 ? (
                                    <div className="w-120px min-w-120px h-20px leading-20px rounded-4px text-center text-12px text-[#ff8000] bg-[#ff8000] bg-opacity-10 whitespace-nowrap mr-10px">正在读取网页...{currProcess}%</div>
                                  ) : (
                                    <div className="w-72px min-w-72px h-20px leading-20px rounded-4px text-center text-12px text-[#00A95B] bg-[#00A95B] bg-opacity-10 whitespace-nowrap mr-10px">已读取完毕</div>
                                  )
                                }
                                <p className="h-20px text-12px leading-20px text-black text-opacity-70 m-0 truncate">
                                  {date ? date : ''} {summary_large}
                                </p>
                              </div>
                                {url && (
                                  <div className="flex items-center h-20px">
                                    {site_name && favicon ? (
                                      <>
                                        <div className="size-16px rounded-full mr-6px overflow-hidden">
                                          <img
                                            className="size-full object-cover"
                                            src={favicon}
                                          />
                                        </div>
                                        <div className="text-12px mr-16px text-black text-opacity-70">
                                          {site_name}
                                        </div>
                                      </>
                                    ) : null}
                                    <p
                                      className="text-12px leading-20px text-[#006AFF] text mb-0 truncate w-0 flex-grow"
                                      title={url}
                                    >
                                      {url}
                                    </p>
                                  </div>
                                )}
                            </div>
                          </div>
                          {
                            currProcess < 100 ? (
                              <div
                                className="h-2px absolute left-0 bottom-0 search-process"
                                style={{width: `${currProcess}%`}}
                              ></div>
                            ) : null
                          }
                        </a>
                      </li>
                    )
                  })
                }
                </ul>
                </>
              )
            }
            </>
          ) : null
        }

        {
          alignValue === '拆词' ? (
            <div className="text-14px text-black leading-18px">
              <div className="mt-10px mb-16px">根据原问题拆解了 {queryList.length} 个搜索关键词</div>
              <div className="bg-white rounded-12px pb-16px whitespace-pre-wrap text-14px text-black leading-22px break-all">
                {
                  queryList.map((keyWord, index) => {
                    return (
                      <div
                        key={`queryList-${index}`}
                        className='flex gap-8px mb-8px items-center'
                      >
                        <SVGPureIcon 
                          name="mcp-search"
                          size={16}
                        />
                        <div className='text-black w-0 flex-grow line-clamp-1' title={keyWord}>
                          {keyWord}
                        </div>
                      </div>
                    )
                  })
                }
              </div>
          </div>
          ) : null
        }

        {
          alignValue === '工具参数' ? (
            <div className="whitespace-pre-wrap text-14px text-black leading-24px break-all">
              <Code
                data={'```json\n' + mcpStore.getNodeParamsText(event)?.trim() + '\n```'}
                className="whitespace-pre-wrap"
                syntaxClassName="language-json"
                light={false}
                showLineNumbers={true}
              />
              {/* {mcpStore.getNodeParamsText(event)} */}
            </div>
          ) : null
        }
      </div>
    </>
  )
});

export default CardNewSearch;